import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { CurrentUserService } from 'app/core/services/auth/current-user.service';
import { PatientsService } from 'app/core/services/patient/patients.service';
import { PermissionService } from 'app/core/services/user/permission.service';

@Component({
  selector: 'app-ask-to-specialist-modal',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './ask-to-specialist-modal.component.html',
  styleUrl: './ask-to-specialist-modal.component.scss',
})
export class AskToSpecialistModalComponent implements OnInit {
  @ViewChild('backdrop', { read: ElementRef }) backdrop: ElementRef;
  @ViewChild('card', { read: ElementRef }) card: ElementRef;

  constructor(
    public activeModal: NgbActiveModal,
    private patientService: PatientsService,
    private currentUserService: CurrentUserService,
    private sanitizer: DomSanitizer,
    private permissionService: PermissionService,
  ) { }

  authenticaedUserInfo: any;
  patientId: string;
  patientName: string;
  patientSurname: string;
  qrCodeUrl: SafeUrl | null = null;
  isPwa = false;
  qrButtonLink: string;

  ngOnInit(): void {
    this.authenticaedUserInfo = this.currentUserService.GetSession();
    this.generateQrCode();
    this.checkPwaMode();
  }

  close() {
    this.triggerCloseAnimation();
  }

  private triggerCloseAnimation() {
    if (this.backdrop && this.card) {
      this.backdrop.nativeElement.classList.add('closing');
      this.card.nativeElement.classList.add('closing');
      
      // Wait for animation to complete before closing
      setTimeout(() => {
        this.activeModal.close();
      }, 300);
    } else {
      this.activeModal.close();
    }
  }

  generateQrCode() {
    this.patientService
      .generatePatientQrCodeForConsultation(
        this.patientId,
        this.authenticaedUserInfo.id,
        `${this.authenticaedUserInfo.firstName} ${this.authenticaedUserInfo.lastName}`,
      )
      .subscribe((response: Blob) => {
        const objectURL = URL.createObjectURL(response);
        this.qrCodeUrl = this.sanitizer.bypassSecurityTrustUrl(objectURL);
      });
  }

  checkPwaMode() {
    this.isPwa =
      window.matchMedia('(display-mode: standalone)').matches ||
      (window.navigator as any).standalone ||
      document.referrer.includes('android-app://');

    if (this.isPwa) {
      const nurseName = `${this.currentUserService.GetSession().firstName} ${this.currentUserService.GetSession().lastName
        }`;

      this.qrButtonLink = `sorelogic://consultation?patientId=${encodeURIComponent(
        this.patientId,
      )}&patientName=${encodeURIComponent(
        this.patientName,
      )}&patientSurname=${encodeURIComponent(
        this.patientSurname,
      )}&nurseId=${encodeURIComponent(
        this.currentUserService.GetSession().id,
      )}&nurseName=${encodeURIComponent(nurseName)}`;
    }
  }

  goToUrl() {
    if (!this.qrButtonLink) return;
    window.location.href = this.qrButtonLink;
  }
}
